// sections/SectionRPLCredit.jsx
import React from 'react';
import { Award } from 'lucide-react';
import { Row, Col, Input, Select, SectionTitle, FormField, FileInput } from '../../../SharedInputs.jsx';

export function SectionRPLCredit({ value, onChange, errors = [], dispatch }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  const updateCreditEvidence = (files) => {
    dispatch({
      type: 'SET_FILES',
      section: 'rplCredit',
      field: 'creditEvidence',
      files: Array.from(files)
    });
  };

  return (
    <div>
      <SectionTitle icon={Award} step={11}>Recognition of Prior Learning (RPL) & Credit Transfer</SectionTitle>
      
      <div style={{
        padding: 16,
        background: '#f8faff',
        borderRadius: 8,
        border: '1px solid #e0e7ff',
        marginBottom: 24
      }}>
        <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>
          Please complete this section if you believe you are eligible to apply for Recognition of Prior Learning (RPL)
          or for Credit Transfer. If you have studied or are currently studying at another academic institution, 
          you may be eligible for credit/advanced standing towards your degree at CIET. Please refer to the 
          CIET Credit for Prior Learning Policy 
          available on the CIET website 
          (<a href='www.ciet.edu.au' target='Blank'>www.ciet.edu.au</a>) for further information on 
          the process and the application deadline.
        </p><br/>
        <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}><b>Please note: </b> Applications for Credit should 
          be submitted at the time of application to the course. </p>
      </div>

      <Row>
        <Col span={6}>
          <FormField label="Apply for credit transfer?">
            <Select value={value.applyCreditTransfer} onChange={(e) => updateField('applyCreditTransfer', e.target.value)}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>
        </Col>
        <Col span={6}>
          <FormField label="If yes, specify units/subjects">
            <Input
              value={value.creditUnits}
              onChange={(e) => updateField('creditUnits', e.target.value)}
              placeholder="List units for credit transfer"
            />
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <FormField label="Apply for Recognition of Prior Learning (RPL)?">
            <Select value={value.applyRPL} onChange={(e) => updateField('applyRPL', e.target.value)}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>
        </Col>
        <Col span={6}>
          <FormField label="If yes, specify units/subjects">
            <Input
              value={value.rplUnits}
              onChange={(e) => updateField('rplUnits', e.target.value)}
              placeholder="List units for RPL assessment"
            />
          </FormField>
        </Col>
      </Row>

      {(value.applyCreditTransfer === "Yes" || value.applyRPL === "Yes") && (
        <Row>
          <Col span={12}>
            <FormField label="Upload supporting evidence">
              <FileInput
                multiple
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                onChange={updateCreditEvidence}
                value={value.creditEvidence}
                placeholder="Upload certificates, transcripts, work portfolios"
              />
            </FormField>
          </Col>
        </Row>
      )}
    </div>
  );
}